<template>
  <div class="menuGroup pl-3 pr-3 pt-2 pb-2">
    <div class="menu">
      <div
        class="row menuRow"
        @click="go">
        <div
          :class="{'col-10': subMenus.length > 0, 'col-12': subMenus.length === 0}"
          class="text-left" >
          <span
            :class="{'menuTextActif' : showSubMenu}"
            class="menuText non-selectable-text"><slot/></span>
        </div>
        <div
          v-if="subMenus.length > 0"
          class="col-2 chevron justify-content-end">
          <i
            v-if="!showSubMenu"
            class="fas fa-chevron-down"/>
          <i
            v-if="showSubMenu"
            class="fas fa-chevron-up"/>
        </div>
      </div>
      <transition name="slide-y">
        <div
          v-if="showSubMenu"
          class="subMenu row">
          <div class="col-12">
            <SubMenuItem
              v-for="(subMenu, index) in subMenus"
              :to="subMenu.to"
              :query="subMenu.query"
              :key="index"
              @click="emitClick">{{ $t(subMenu.text) }}</SubMenuItem>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import IconLink from '@/components/Utils/IconLink';
import SubMenuItem from '@/components/Menu/SubMenuItem';

export default {
  name: 'MenuItem',
  components: {
    IconLink,
    SubMenuItem,
  },
  props: {
    to: {
      type: String,
      default: null,
    },
    subMenus: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showSubMenu: false,
    };
  },
  methods: {
    go() {
      if (this.to) {
        this.$router.push(this.to);
        this.emitClick();
      } else {
        this.showSubMenu = !this.showSubMenu;
      }
    },
    emitClick() {
      this.$emit('click');
    },
  },
};
</script>

<style scoped lang="scss">
div {
  &.menuGroup {
    border-bottom: 1px solid $primary;
  }

  &.column {
    display: flex;
    align-items: center;
  }

  &.chevron {
    font-size: 25px;
    color: $primary;
    display: flex;
    align-items: center;
  }

  &.subMenu {
    overflow: hidden;
  }
}

.menuRow {
  cursor: pointer;
}

span {
  &.menuText {
    font-size: 1.75rem;
    color: $primary;
  }
  &.menuTextActif {
    color: $gray-500;
  }
}

.slide-y-enter-active,
.slide-y-leave-active {
  transition: all 0.5s;
  max-height: 200px;
}
.slide-y-enter,
.slide-y-leave-to {
  max-height: 0;
}
</style>
